import React, { useState, useEffect } from 'react';
import { Button, Card, Row, Col, Carousel, Input, notification } from 'antd';
import axios from 'axios';
import { API_URL as PRODUCTO_API_URL } from '../../apis/apiProductos';  // Ajusta según tu configuración de API
import { API_URL as MARCA_API_URL } from '../../apis/apiMarcas';  // Ajusta según tu configuración de API
import './css-admin/adminTienda.css';

const AdminTienda = () => {
  const [productos, setProductos] = useState([]); // Para almacenar todos los productos
  const [filteredProductos, setFilteredProductos] = useState([]); // Para almacenar los productos filtrados
  const [marcas, setMarcas] = useState([]); // Para almacenar las marcas
  const [filteredMarcas, setFilteredMarcas] = useState([]); // Para almacenar las marcas filtradas por categoría
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null); // Categoría seleccionada
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(null); // Estado seleccionado (1 o 2)
  const [searchTerm, setSearchTerm] = useState(''); // Estado para el término de búsqueda

  // Obtener productos y marcas al cargar el componente
  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const response = await axios.get(PRODUCTO_API_URL);
        setProductos(response.data);  // Guardar productos sin filtrar
        setFilteredProductos(response.data);  // Inicialmente mostramos todos los productos
      } catch (error) {
        console.error('Error al obtener productos:', error);
      }
    };

    const fetchMarcas = async () => {
      try {
        const response = await axios.get(MARCA_API_URL);
        setMarcas(response.data); 
      } catch (error) {
        console.error('Error al obtener marcas:', error);
      }
    };

    fetchProductos();
    fetchMarcas();
  }, []);

  // Filtrar productos por categoría
  const filtrarPorCategoria = (categoriaId) => {
    const productosFiltrados = productos.filter(producto => producto.categoria === categoriaId);
    setFilteredProductos(productosFiltrados);
    setCategoriaSeleccionada(categoriaId);
  
    if (categoriaId === 1) {
      setFilteredMarcas(marcas.filter(marca => [1, 2, 3, 4, 5].includes(marca.id)));
    } else if (categoriaId === 2) { 
      setFilteredMarcas(marcas.filter(marca => [7, 8].includes(marca.id)));
    } else if (categoriaId === 3) { 
      setFilteredMarcas(marcas.filter(marca => [6, 9, 10, 11, 12].includes(marca.id)));
    }
  };

  // Filtrar productos por marca
  const filtrarPorMarca = (marcaId) => {
    const productosFiltradosPorMarca = productos.filter(producto => producto.marca === marcaId && producto.categoria === categoriaSeleccionada);
    setFilteredProductos(productosFiltradosPorMarca);
  };

  // Filtrar productos por estado
  const filtrarPorEstado = (estadoId) => {
    const productosFiltradosPorEstado = productos.filter(producto => producto.estado === estadoId);
    setFilteredProductos(productosFiltradosPorEstado);
    setEstadoSeleccionado(estadoId); // Guardamos el estado seleccionado
  };

  // Mostrar todos los productos
  const mostrarTodosLosProductos = () => {
    setFilteredProductos(productos); // Restablecer la lista de productos
    setFilteredMarcas([]); // Limpiar las marcas filtradas
    setCategoriaSeleccionada(null); // Resetear la categoría seleccionada
    setEstadoSeleccionado(null); // Resetear el estado seleccionado
  };

  const onSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    const productosFiltrados = productos.filter(producto => producto.nombre.toLowerCase().includes(term));
    setFilteredProductos(productosFiltrados);
  };

  // Función para cambiar el estado del producto
  const cambiarEstadoProducto = async (productoId, nuevoEstado) => {
    try {
      await axios.patch(`${PRODUCTO_API_URL}${productoId}/`, { estado: nuevoEstado });

      // Actualizar los productos localmente
      const productosActualizados = productos.map(producto =>
        producto.id === productoId ? { ...producto, estado: nuevoEstado } : producto
      );
      setProductos(productosActualizados);
      setFilteredProductos(productosActualizados);

      notification.success({
        message: 'Estado actualizado',
        description: `El estado del producto ha sido cambiado a ${nuevoEstado}.`,
        placement: 'topRight',
      });
    } catch (error) {
      console.error('Error al cambiar el estado del producto:', error);
      notification.error({
        message: 'Error',
        description: 'Hubo un error al cambiar el estado del producto.',
        placement: 'topRight',
      });
    }
  };

  return (
    <section>
      <div className="admin-catalogo-container">
        <div className="admin-busqueda-top">
          <h2>Administrar Productos</h2>
  
          {/* Barra de búsqueda */}
          <div>
            <Input
              placeholder="Buscar productos por nombre"
              value={searchTerm}
              onChange={onSearchChange}
            />
          </div>
  
          {/* Botones para filtrar productos por categoría */}
          <div>
            <Button onClick={mostrarTodosLosProductos}>Ver Todo</Button>
            <Button onClick={() => filtrarPorCategoria(1)}>Ver Maquinas</Button>
            <Button onClick={() => filtrarPorCategoria(2)}>Ver Agujas</Button>
            <Button onClick={() => filtrarPorCategoria(3)}>Ver Utileria</Button>
          </div>
  
          {/* Botones para filtrar productos por marca */}
          {filteredMarcas.length > 0 && (
            <div>
              {filteredMarcas.map((marca) => (
                <Button
                  key={marca.id}
                  onClick={() => filtrarPorMarca(marca.id)}
                >
                  {marca.nombre}
                </Button>
              ))}
            </div>
          )}
  
          {/* Botones para filtrar productos por estado */}
          <div>
            <Button
              type={estadoSeleccionado === 1 ? 'primary' : 'default'}
              onClick={() => filtrarPorEstado(1)}
            >
              Ver Estado Visible
            </Button>
            <Button
              type={estadoSeleccionado === 2 ? 'primary' : 'default'}
              onClick={() => filtrarPorEstado(2)}
            >
              Ver Estado Invisible
            </Button>
          </div>
        </div>
  
        {/* Mostrar productos filtrados */}
        <Row gutter={[16, 16]} className="productos-row">
          {filteredProductos.length > 0 ? (
            filteredProductos.map((producto) => (
              <Col
                key={producto.id}
                xs={24}
                sm={12}
                md={8}
                lg={6}
                className="producto-col"
              >
                <Card hoverable className="producto-card">
                  {/* Carrusel para las imágenes del producto */}
                  <Carousel autoplay pauseOnHover className="producto-carousel">
                    {producto.imagenes.map((imagen) => (
                      <div key={imagen.id} className="producto-carousel-slide">
                        <img
                          alt={`Imagen de ${producto.nombre}`}
                          src={imagen.imagen}
                          className="producto-imagen"
                        />
                      </div>
                    ))}
                  </Carousel>
  
                  {/* Información del producto */}
                  <Card.Meta
                    title={producto.nombre}
                    description={
                      <div className="producto-info">
                        <p className="producto-serie">
                          Modelo: {producto.modelo}
                        </p>
                        <p className="producto-descripcion">
                          Descripción: {producto.descripcion}
                        </p>
                      </div>
                    }
                  />
  
                  {/* Botones para cambiar el estado */}
                  <div className="producto-botones">
                    <Button
                      type={producto.estado === 1 ? 'primary' : 'default'}
                      onClick={() => cambiarEstadoProducto(producto.id, 1)}
                      className={`producto-boton ${
                        producto.estado === 1 ? 'boton-visible' : ''
                      }`}
                    >
                      Cambiar a Estado Visible
                    </Button>
                    <Button
                      type={producto.estado === 2 ? 'primary' : 'default'}
                      onClick={() => cambiarEstadoProducto(producto.id, 2)}
                      className={`producto-boton ${
                        producto.estado === 2 ? 'boton-invisible' : ''
                      }`}
                    >
                      Cambiar a Estado Invisible
                    </Button>
                  </div>
                </Card>
              </Col>
            ))
          ) : (
            <p className="productos-mensaje">
              No hay productos disponibles para esta categoría, marca o estado.
            </p>
          )}
        </Row>
      </div>
    </section>
  );  
};

export default AdminTienda;
